
  import { defineComponent } from 'vue';

  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';
  import type { TEchartsBarDatasetItem, TEChartsTitleConfig } from '@/components/ChartComponents/apacheEcharts/types';

  type TBaseLineChartProps = {
    xData: string[];
    lineolor: string;
    valueFractionDigits: number;
    valuePostfix: string;
  };

  type TLineChartTitleConfigs = {
    investments: TEChartsTitleConfig;
    investmentsToGdp: TEChartsTitleConfig;
    goodsTrade: TEChartsTitleConfig;
    mutualServices: TEChartsTitleConfig;
  };

  const LINE_CHART_TITLE_CONFIGS: Readonly<TLineChartTitleConfigs> = {
    investments: Object.freeze({
      text: 'Инвестиции в рамках ЕАЭС (млн $ США)',
    }),
    investmentsToGdp: Object.freeze({
      text: 'Прямые инвестиции в процентах ВВП',
      level: 4,
    }),
    goodsTrade: Object.freeze({
      text: 'Взаимная торговля товарами (млн руб)',
      level: 4,
    }),
    mutualServices: Object.freeze({
      text: 'Взаимные услуги государств – членов ЕАЭС',
    }),
  };

  export default defineComponent({
    name: 'Tes',
    components: { EChartsVerticalBar, EChartsLine, IconComponent, SectionTitle },
    computed: {
      getServicesGdpShareLabels(): string[] {
        return ['Россия', 'Армения', 'Беларусь', 'Казахстан', 'Киргизия'];
      },
      getServicesGdpShareDataset(): TEchartsBarDatasetItem[] {
        return [
          {
            label: '',
            data: [100, 500, 400, 10, 20],
            color: '#0093BA',
          },
        ];
      },
      getBaseLineChartProps(): TBaseLineChartProps {
        return {
          xData: ['2018', '2019', '2020', '2021', '2022'],
          lineolor: '#0093BA',
          valueFractionDigits: 0,
          valuePostfix: '',
        };
      },
      getLineChartTitleConfigs(): Readonly<TLineChartTitleConfigs> {
        return LINE_CHART_TITLE_CONFIGS;
      },
    },
  });
